import {graphql} from 'gatsby';
import React, {memo} from 'react';
import Carousel from 'react-slick';

import style from './image-carousel.module.scss';

import RatioImage from './ratio-image';

export const query = graphql`
	fragment ImageCarousel on Image {
		...RatioImage
	}
`;

export default memo(
	/**
	 * @param {{
	 *   images: Array<import("../../tmp/graphql-types").ImageCarouselFragment>,
	 * }} props
	 * @returns {React.ReactElement | null} ...
	 */
	function ImageCarousel({images}) {
		if (images.length === 0) {
			return null;
		}

		if (images.length === 1) {
			// render the one image... *react-slick* wouldn't work with one image anyway
			return (
				<RatioImage {...images[0]} />
			);
		}

		return (
			<div className={style.carouselWrapper}>
				<Carousel
					dots={true}
					infinite={true}
					adaptiveHeight={true}
					arrows={false}
					className={style.carousel}

					// react-slick overrides slick's default and does not set
					// required a11y attributes (type, role)
					customPaging={(i) => (
						<button
							className={style.pagingButton}
							type="button"
							data-role="none"
							role="button"
							tabIndex={0}
							title={`${i + 1}`}
						>
							{i + 1}
						</button>
					)}
				>
					{images.map((img, i) => (
						<RatioImage key={i} {...img} />
					))}
				</Carousel>
			</div>
		);
	}
);
